const DownloadPdf = (pdfString, name) => {
  const downloadLink = document.createElement('a');
  downloadLink.href = `data:application/pdf;base64,${pdfString}`;
  downloadLink.download = name;
  downloadLink.click();
};

export default DownloadPdf;
